export default __webpack_public_path__ + "images/56bfb358a1ba15a17d27feadc31d859c-august_banner_mobile-2.webp";